import { useState, useEffect, useContext } from 'react';
import { I18n } from '@boschebike/ebds-js';
import { getContent } from '../i18n/content';
import { LocalizationContext } from '../context/localizationContext';

export const useContent = (langCode?: string): I18n => {
  const [content, setContent] = useState<I18n>({ t: () => '' });
  const localizationContext = useContext(LocalizationContext);
  const currentLangCode = langCode ?? localizationContext.locale;

  const createPageContent = async () => {
    if (currentLangCode.length) {
      setContent(await getContent(currentLangCode));
    }
  };

  useEffect(() => {
    createPageContent();
  }, [langCode, localizationContext]);

  return content;
};
